"use client";

import type { ButtonHTMLAttributes } from "react";
import { ArtistIcon } from "../icons/ArtistIcon";

export interface MoreDotsButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement> {
	readonly label?: string;
}

/**
 * MoreDotsButton — circular "more" trigger (three dots). Mirrors
 * `DSMoreDotsButton` on iOS. Defaults to a 44×44 glass icon button.
 */
export function MoreDotsButton({
	label = "更多",
	className = "",
	...props
}: Readonly<MoreDotsButtonProps>) {
	return (
		<button
			className={`ds-icon-button ${className}`.trim()}
			aria-label={label}
			{...props}
		>
			<ArtistIcon name="more" size={20} />
		</button>
	);
}
